import { COMPLIANCE_REQUEST_INSTANCES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/compliance_request_instances_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'buyerComplianceOverview',
	'complianceRequestDetailInstances',
	'supplierComplianceOverview',
	'supplierComplianceRequestsList',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
